export function showSnack(message) {
    var snackbarContainer = document.querySelector('#toast');
    var data = {
        message: message
    };
    snackbarContainer.MaterialSnackbar.showSnackbar(data);
}


// WEBPACK FOOTER //
// ./src/household.js